import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Divider,
  Switch,
} from "@mui/material";
import { DoubleArrow } from "@mui/icons-material";
import { CustomTextBox } from "components/CustomComponents";
import { useForm } from "react-hook-form";
import { useFetch } from "services/hooks/useFetch";
import { customGetAPI } from "services/utils/CustomAPI";
import {
  CustomButtonWithBorder,
  CustomButton,
} from "components/CustomComponents/CustomButton";
import { customAPI } from "services/utils/CustomAPI";
import {
  doubleArrowStyle,
  themes,
  parentBoxStyle,
  childBoxStyleWithColor,
  infoStyle,
  toAlignEnd,
  childBoxStyle,
  childBoxStyleSpaceBetween,
  validateFormulaPattern,
} from "services/constants";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { Controller } from "react-hook-form";
import {
  onlyNumberRegex,
  atleastOneCharacterWithSpace,
} from "services/constants/patterns";
import { CustomAutoComplete } from "components/CustomComponents";
import { CustomButtonWithOutLoader } from "components/CustomComponents/CustomButton";
import { CustomMultiSelectionWithLabel } from "components/CustomComponents/CustomMultiSelectionWithLabel";
import { defaultAllSelection } from "services/constants";

export const NewSalaryComponent = ({ onClose, reCallApi, setHanldeLoader }) => {
  const { domain, token, topbarCompanyId, topbarCompanyName } = useSelector(
    (state) => state.tokenReducer
  );
  const {
    setValue,
    handleSubmit,
    register,
    watch,
    control,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      company_name: topbarCompanyName === "All" ? "" : topbarCompanyName,
      company_id:
        topbarCompanyId === defaultAllSelection ? "" : topbarCompanyId,
      name: "",
      code: "",
      component_category: "",
      computation_method: "",
      amount: "",
      formula: "",
      percentage: "",
      value_based_on: [],
      include_in_gross: false,
      include_in_ctc: false,
      include_in_tds: false,
      show_in_payslip: false,
      is_exists: false,
    },
  });
  const { result: componentCategoryData } = useFetch(
    `${domain}HRZone/Salary/Salary_Component/get-component-category-choices/`
  );
  const { result: computationMethodData } = useFetch(
    `${domain}HRZone/Salary/Salary_Component/get-computation-method-choices/`
  );
  const { result: valueBasedOnData, setLoad: recallValueBasedApi } = useFetch(
    `${domain}HRZone/Salary/Salary_Component/get-values-basedon/?company_id=${watch(
      "company_id"
    )}`
  );
  const filteredValueBasedOnData = valueBasedOnData.filter(
    (item) => item?.label?.toUpperCase() !== "SP"
  );

  let companyDetails = localStorage.getItem("companyAccess")
    ? JSON.parse(localStorage.getItem("companyAccess"))
    : [];

  const onSubmit = async (data) => {
    setValue("button_loader", true);
    const response = await customAPI(
      `${domain}HRZone/Salary/Salary_Component/salary-component-list/`,
      "POST",
      {
        company_id: data?.company_id,
        name: data?.name,
        code: data?.code,
        component_category: data?.component_category,
        computation_method: data?.computation_method,
        value:
          data?.computation_method === "Fixed Amount"
            ? data?.amount
            : data?.computation_method === "Percentage"
            ? data?.percentage
            : data?.formula,
        value_based_on: data?.value_based_on,
        description: data?.description,
        include_in_gross: data?.include_in_gross,
        include_in_ctc: data?.include_in_ctc,
        include_in_tds: data?.include_in_tds,
        show_in_payslip: data?.show_in_payslip,
      }
    );
    if (response.ok) {
      showToast("success", response?.responseDetails?.message);
      setValue("button_loader", false);
      onClose();
      setHanldeLoader(false);
      reCallApi(true);
    } else {
      setValue("button_loader", false);
      showToast("error", response?.message);
    }
  };

  const handleName = (event) => {
    if (event.target.value) {
      setValue("name", event.target.value);
    } else {
      setValue("name", "");
    }
  };

  const handleCode = (event) => {
    if (event.target.value) {
      let val = event.target.value.toUpperCase();
      val = val.replace(/[^A-Z]/g, "");
      val = val.slice(0, 5);
      setValue("code", val);
    } else {
      setValue("code", "");
    }
  };

  const handleCompanyName = (event, data) => {
    if (data) {
      setValue("company_name", data?.label);
      setValue("company_id", data?.id);
      recallValueBasedApi(true);
    } else {
      setValue("company_name", "");
      setValue("company_id", "");
    }
  };

  const handleComponentCategory = (event, data) => {
    if (data) {
      setValue("component_category", data?.label);
      setValue("computation_method", "");
    } else {
      setValue("component_category", "");
    }
  };

  const handleComputationMethod = (event, data) => {
    if (data) {
      setValue("computation_method", data?.label);
      setValue("amount", "");
      setValue("formula", "");
      setValue("percentage", "");
    } else {
      setValue("computation_method", "");
    }
  };

  const handlePercentage = (event) => {
    if (
      /^(100(\.0{0,2})?|(\d{1,2})(\.\d{0,2})?)$/.test(event.target.value) ||
      event.target.value === ""
    ) {
      setValue("percentage", event.target.value);
    } else {
      setValue("percentage", "");
    }
  };

  const hanldeAmount = (event) => {
    if (
      event.target.value.length <= 8 &&
      onlyNumberRegex.test(event.target.value)
    ) {
      setValue("amount", event.target.value);
    } else {
      setValue("amount", "");
    }
  };

  const handleFormula = (event) => {
    const value = event.target.value.replace(/[a-z]/g, (ch) =>
      ch.toUpperCase()
    );
    setValue("formula", value);
  };

  const handleDescription = (event) => {
    if (event.target.value) {
      setValue("description", event.target.value);
    } else {
      setValue("description", "");
    }
  };

  const handleValidateFormula = async () => {
    setValue("loading", true);
    const res = await customGetAPI(
      `${domain}HRZone/Salary/Salary_Component/validate-component-value/?value=${watch(
        "formula"
      )}`
    );
    if (res.ok) {
      showToast(
        res?.responseDetails?.valid ? "success" : "error",
        res?.responseDetails?.message
      );
      setValue("loading", false);
      setValue("is_exists", res?.responseDetails?.valid);
    } else {
      showToast("error", res?.message);
      setValue("loading", false);
    }
  };

  return (
    <Box sx={parentBoxStyle}>
      <Paper
        elevation={0}
        sx={{
          borderBottom: `1px solid ${themes?.miliedLightGray}`,
          borderRadius: 0,
        }}
      >
        <Box sx={childBoxStyleWithColor}>
          <Box sx={{ ml: 1 }}>
            <IconButton onClick={onClose} sx={doubleArrowStyle}>
              <DoubleArrow />
            </IconButton>
          </Box>

          <Box sx={{ ml: 2.2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Add Salary Component
            </Typography>
            <Typography {...infoStyle}>
              Add or configure components that make up the employee’s salary,
              including allowances, deductions, and contributions.
            </Typography>
          </Box>
        </Box>
      </Paper>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box sx={childBoxStyle}>
            <Box>
              <Box>
                <Typography sx={{ fontWeight: 600 }}>Company Name</Typography>
                <Typography {...infoStyle}>
                  Select the company for which this component appliess
                </Typography>
                <CustomAutoComplete
                  dataList={companyDetails
                    .filter((obj) => obj.company_name !== "All")
                    .map((obj) => ({
                      id: obj.company_id,
                      label: obj.company_name,
                    }))}
                  rules={{
                    ...register("company_name", {
                      required: "Company Name is required",
                    }),
                  }}
                  selectedValue={watch("company_name")}
                  updateDataFunction={handleCompanyName}
                  placeHolder="Select company name"
                  errorMessage={
                    errors?.company_name?.message
                      ? errors?.company_name?.message
                      : ""
                  }
                  textBoxError={errors?.company_name ? true : false}
                />
              </Box>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>Component Name</Typography>
              <Typography {...infoStyle}>
                Enter a readable name (e.g., Basic Pay, Bonus, Overtime).
              </Typography>
              <CustomTextBox
                selectedValue={watch("name")}
                rules={{
                  ...register("name", {
                    required: "component name is required",
                    maxLength: {
                      value: 100,
                      message: "Maximum length is 100 characters",
                    },
                    validate: {
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                      checkComponentUniqueName: async (fieldValue) => {
                        if (fieldValue !== "") {
                          const response = await fetch(
                            `${domain}HRZone/Salary/Salary_Component/check-component-name/?component_name=${fieldValue.trim()}&company_id=${watch(
                              "company_id"
                            )}`,
                            {
                              method: "GET",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `token ${token}`,
                              },
                            }
                          );
                          const resp = await response.json();
                          if (resp.exists) {
                            return "Component name already exists";
                          }
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={handleName}
                placeHolder="Enter component name"
                errorMessage={
                  errors?.name?.message ? errors?.name?.message : ""
                }
                textBoxError={errors.name ? true : false}
              />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>Code</Typography>
              <Typography {...infoStyle}>
                Unique short code (e.g., BASIC, OT,HRA).
              </Typography>
              <CustomTextBox
                selectedValue={watch("code")}
                rules={{
                  ...register("code", {
                    required: "code is required",
                    minLength: {
                      value: 2,
                      message: "Minium length is 2 characters",
                    },
                    maxLength: {
                      value: 5,
                      message: "Maximum length is 5 characters",
                    },
                    validate: {
                      checkComponentUniqueName: async (fieldValue) => {
                        if (fieldValue !== "") {
                          const response = await fetch(
                            `${domain}HRZone/Salary/Salary_Component/check-component-code/?company_id=${watch(
                              "company_id"
                            )}&code=${fieldValue.trim()}`,
                            {
                              method: "GET",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `token ${token}`,
                              },
                            }
                          );
                          const resp = await response.json();
                          if (resp.exists) {
                            return "Component code already exists";
                          }
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={handleCode}
                placeHolder="Enter component name"
                errorMessage={
                  errors?.code?.message ? errors?.code?.message : ""
                }
                textBoxError={errors.code ? true : false}
              />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>
                Component Category
              </Typography>
              <Typography {...infoStyle}>
                Select how this component will appear on payslips (Earnings,
                Other Earnings, Deductions, etc.).  
              </Typography>
              <CustomAutoComplete
                dataList={componentCategoryData}
                rules={{
                  ...register("component_category", {
                    required: "Component category is required",
                  }),
                }}
                selectedValue={watch("component_category")}
                updateDataFunction={handleComponentCategory}
                placeHolder="Select component category"
                errorMessage={
                  errors?.component_category?.message
                    ? errors?.component_category?.message
                    : ""
                }
                textBoxError={errors?.component_category ? true : false}
              />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>
                Computation Method
              </Typography>
              <Typography {...infoStyle}>
                Choose how the value is calculated — Fixed, Percentage, Formula,
                etc. 
              </Typography>
              <CustomAutoComplete
                dataList={
                  watch("component_category") === "Reimbursement"
                    ? computationMethodData.filter(
                        (item) => item.label === "Fixed Amount"
                      )
                    : computationMethodData
                }
                rules={{
                  ...register("computation_method", {
                    required: "Computation method is required",
                  }),
                }}
                selectedValue={watch("computation_method")}
                updateDataFunction={handleComputationMethod}
                placeHolder="Select computation method"
                errorMessage={
                  errors?.computation_method?.message
                    ? errors?.computation_method?.message
                    : ""
                }
                textBoxError={errors?.computation_method ? true : false}
              />
            </Box>
            {watch("computation_method") === "Percentage" && (
              <>
                <Box>
                  <Typography sx={{ fontWeight: 600 }}>Percentage</Typography>
                  <Typography {...infoStyle}>
                    Provide the percentage value to calculate this component.
                  </Typography>
                  <CustomTextBox
                    selectedValue={watch("percentage")}
                    rules={{
                      ...register("percentage", {
                        required: false,
                        validate: {
                          minLengthNoSpaces: (value) => {
                            if (
                              watch("computation_method") === "Percentage" &&
                              watch("percentage") === ""
                            ) {
                              return "Percentage is required";
                            } else {
                              return true;
                            }
                          },
                        },
                      }),
                    }}
                    updateDataFunction={handlePercentage}
                    placeHolder="Enter the percentage"
                    errorMessage={
                      errors?.percentage?.message
                        ? errors?.percentage?.message
                        : ""
                    }
                    textBoxError={errors.percentage ? true : false}
                  />
                </Box>
                <Box>
                  <Typography sx={{ fontWeight: 600 }}>
                    Percentage Based On
                  </Typography>
                  <Typography {...infoStyle}>
                    Select the salary component or amount on which this
                    percentage should be calculated.
                  </Typography>

                  <Controller
                    name="value_based_on"
                    control={control}
                    rules={{
                      required:
                        watch("computation_method") === "Percentage" &&
                        watch("value_based_on")?.length === 0
                          ? "Percentage based on is required"
                          : false,
                    }}
                    render={({ field }) => (
                      <CustomMultiSelectionWithLabel
                        value={field.value}
                        onChange={field.onChange}
                        options={filteredValueBasedOnData}
                        placeholder="Select payment based on"
                        error={!!errors.value_based_on}
                        helperText={errors.value_based_on?.message}
                      />
                    )}
                  />
                </Box>
              </>
            )}

            {watch("computation_method") === "Fixed Amount" && (
              <Box>
                <Typography sx={{ fontWeight: 600 }}>Amount</Typography>
                <Typography {...infoStyle}>
                  Enter a fixed amount to be applied for this salary component.
                </Typography>
                <CustomTextBox
                  selectedValue={watch("amount")}
                  rules={{
                    ...register("amount", {
                      required: false,
                      validate: {
                        minLengthNoSpaces: (value) => {
                          if (
                            watch("computation_method") === "Fixed Amount" &&
                            watch("amount") === ""
                          ) {
                            return "Amount is required";
                          } else {
                            return true;
                          }
                        },
                      },
                    }),
                  }}
                  updateDataFunction={hanldeAmount}
                  placeHolder="Enter amount"
                  errorMessage={
                    errors?.amount?.message ? errors?.amount?.message : ""
                  }
                  textBoxError={errors.amount ? true : false}
                />
              </Box>
            )}

            {watch("computation_method") === "Formula" && (
              <Box>
                <Typography sx={{ fontWeight: 600 }}>Formula</Typography>
                <Typography {...infoStyle}>
                  Use component codes in formula, e.g. (BA * 0.4) + 500
                </Typography>
                <Box sx={{ ...childBoxStyleSpaceBetween, px: 0, gap: 4 }}>
                  <CustomTextBox
                    selectedValue={watch("formula")}
                    rules={{
                      ...register("formula", {
                        required: false,
                        validate: {
                          requiredFormula: (value) => {
                            if (
                              watch("computation_method") === "Formula" &&
                              (!value || value.trim() === "")
                            ) {
                              return "Formula is required";
                            }
                            return true;
                          },
                          noSPAllowed: (value) => {
                            if (!value) return true;
                            const hasSP = /\bSP\b/.test(value);
                            if (hasSP) {
                              return "SP is not a valid choice in formula";
                            }
                            return true;
                          },
                          formulaPattern: (value) => {
                            if (value && !validateFormulaPattern(value)) {
                              return "Invalid formula pattern";
                            }
                            return true;
                          },
                        },
                      }),
                    }}
                    updateDataFunction={handleFormula}
                    placeHolder="Enter formula"
                    errorMessage={
                      errors?.formula?.message ? errors?.formula?.message : ""
                    }
                    textBoxError={errors.formula ? true : false}
                  />

                  <Box>
                    <CustomButton
                      actionFuntion={async () => {
                        const isValid = await trigger("formula");

                        if (isValid) {
                          handleValidateFormula();
                        }
                      }}
                      actionName="Validate"
                      typeName="submit"
                      disableAction={watch("loading")}
                    />
                  </Box>
                </Box>
              </Box>
            )}

            <Box>
              <Typography sx={{ fontWeight: 600 }}>Description</Typography>
              <Typography {...infoStyle}>
                Explain the component or its rule (internal note).
              </Typography>
              <CustomTextBox
                type="multiline"
                selectedValue={watch("description")}
                rules={{
                  ...register("description", {
                    required: "Description is required",
                    validate: {
                      minLengthNoSpaces: (value) => {
                        if (value?.trim().length > 255 && value !== "") {
                          return "Maximum length is 255 characters";
                        } else {
                          return true;
                        }
                      },
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={handleDescription}
                placeHolder="Enter description"
                errorMessage={
                  errors?.description?.message
                    ? errors?.description?.message
                    : ""
                }
                textBoxError={errors.description ? true : false}
              />
            </Box>

            <Divider />

            <Box>
              <Typography sx={{ fontWeight: 600 }}>
                Component Inclusion Settings
              </Typography>
              <Typography {...infoStyle}>
                Set how this component is treated in salary calculations and
                payslip display.
              </Typography>
            </Box>

            <Box sx={childBoxStyleSpaceBetween}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontWeight: 600 }}>
                  Include in Gross
                </Typography>
                <Typography {...infoStyle}>
                  Adds this component to the employee’s gross salary.
                </Typography>
              </Box>
              <Switch
                checked={watch("include_in_gross")}
                onChange={(event) => {
                  setValue("include_in_gross", event.target.checked);
                }}
              />
            </Box>

            <Box sx={childBoxStyleSpaceBetween}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontWeight: 600 }}>Include in CTC</Typography>
                <Typography {...infoStyle}>
                  Includes this component when calculating the employee’s total
                  CTC.
                </Typography>
              </Box>
              <Switch
                checked={watch("include_in_ctc")}
                onChange={(event) => {
                  setValue("include_in_ctc", event.target.checked);
                }}
              />
            </Box>
            <Box sx={childBoxStyleSpaceBetween}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontWeight: 600 }}>Include in TDS</Typography>
                <Typography {...infoStyle}>
                  Marks this amount as taxable for TDS calculation.
                </Typography>
              </Box>
              <Switch
                checked={watch("include_in_tds")}
                onChange={(event) => {
                  setValue("include_in_tds", event.target.checked);
                }}
              />
            </Box>
            <Box sx={childBoxStyleSpaceBetween}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontWeight: 600 }}>
                  Show in Payslip
                </Typography>
                <Typography {...infoStyle}>
                  Displays this component in the employee’s payslip.
                </Typography>
              </Box>
              <Switch
                checked={watch("show_in_payslip")}
                onChange={(event) => {
                  setValue("show_in_payslip", event.target.checked);
                }}
              />
            </Box>

            <Box sx={toAlignEnd}>
              <CustomButtonWithBorder
                actionName="Cancel"
                typeName="button"
                actionFuntion={() => onClose()}
              />
              <CustomButtonWithOutLoader
                actionName="Add"
                typeName="submit"
                disableAction={
                  watch("computation_method") === "Formula"
                    ? !watch("is_exists")
                    : watch("button_loader")
                }
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  );
};
